type DeviceType = 'mobile' | 'tablet' | 'desktop'

const MOBILE_MAX_WIDTH = 768
const TABLET_MAX_WIDTH = 1024

export const getDeviceType = (): DeviceType => {
  if (typeof window === 'undefined') return 'desktop'

  const width = window.innerWidth

  if (width < MOBILE_MAX_WIDTH) return 'mobile'
  if (width < TABLET_MAX_WIDTH) return 'tablet'

  return 'desktop'
}
